import React from 'react';
import Radium from 'radium';

const errorStyle = {
	marginBottom: 10,
	color: '#dc0000',
	fontSize: '0.7em',
};

const label = {
	fontSize: '0.8em',
	marginTop: 5,
	marginLeft: 2,
};

const styles = {
	textarea: {
		width: '100%',
		border: '1px solid rgba(34,36,38,.15)',
		transition: 'box-shadow .1s ease,border-color .1s ease',
		padding: 5,
		borderRadius: '4px',
		':focus': {
			border: '1px solid #85b7d9',
			outline: 'none',
		},
		':disabled': {
			backgroundColor: 'white',
			opacity: '.75'
		},
	},
	textareaError: {
		border: '1px solid rgba(255,0,0,.50)',
		backgroundColor: 'rgba(255,0,0,.15)',
		':focus': {
			border: '1px solid red',
			outline: 'none',
		},
	},

	crossRequired: {
		color: '#c5190e',
		fontSize: '1em',
		position: 'relative',
		bottom: 1,
		left: 3,
	},
};

const CustomTextareaComponent = ({
	field,
	form: { touched, errors },
	...props
}) => (
	<div>
		<div style={label}>
			{props.customlabel}
			{props.required && <span style={styles.crossRequired}>*</span>}
		</div>

		<textarea
			{...field}
			{...props}
			placeholder={props.placeholder}
			style={
				Boolean(touched[field.name] && errors[field.name])
					? { ...styles.textarea, ...styles.textareaError }
					: styles.textarea
			}
			maxLength='1000'
		/>
		{touched[field.name] && errors[field.name] && (
			<div style={errorStyle}>{errors[field.name]}</div>
		)}
	</div>
);

export default Radium(CustomTextareaComponent);
